import { Pillar } from '../../../../../../api/theHive/redeProto/types';
import { classificationColor } from '../../theme/tokens';
import { TrendChart } from '../charts/TrendChart';
import { StatusPill } from '../StatusPill';
import {
  Alert,
  Card,
  Head,
  MetricLabel,
  MetricRow,
  MetricValue,
  PillarName,
  Score,
} from './styles';

interface Sparkline {
  labels: string[];
  data: (number | null)[];
}

interface PillarCardProps {
  pillar: Pillar;
  compact?: boolean;
  sparkline?: Sparkline;
}

export function PillarCard({
  pillar,
  compact = false,
  sparkline,
}: PillarCardProps): JSX.Element {
  const accent = classificationColor[pillar.classification];

  return (
    <Card accent={accent}>
      <Head>
        <div>
          <PillarName>{pillar.label}</PillarName>
          <Score accent={accent}>{Math.round(pillar.score)}</Score>
        </div>
        <StatusPill classification={pillar.classification} />
      </Head>

      {!compact && (
        <>
          {sparkline && (
            <TrendChart
              minimal
              height={54}
              labels={sparkline.labels}
              series={[
                { label: pillar.label, color: accent, data: sparkline.data },
              ]}
            />
          )}
          <div>
            {pillar.metrics.map((metric) => (
              <MetricRow key={metric.label}>
                <MetricLabel>{metric.label}</MetricLabel>
                <MetricValue>{metric.value}</MetricValue>
              </MetricRow>
            ))}
          </div>
          {pillar.alerts.map((alert) => (
            <Alert key={alert}>{alert}</Alert>
          ))}
        </>
      )}
    </Card>
  );
}
